module.exports = __webpack_public_path__ + "img/fully_settled.154041a7.svg";